import { render, staticRenderFns } from "./IntegrationsFilter.vue?vue&type=template&id=7c7a4c70"
import script from "./IntegrationsFilter.vue?vue&type=script&lang=js"
export * from "./IntegrationsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7a4c70')) {
      api.createRecord('7c7a4c70', component.options)
    } else {
      api.reload('7c7a4c70', component.options)
    }
    module.hot.accept("./IntegrationsFilter.vue?vue&type=template&id=7c7a4c70", function () {
      api.rerender('7c7a4c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integrations-filter/IntegrationsFilter.vue"
export default component.exports